import customHeadersModalController from "../../../maintainCustomHeaders/customHeadersModal/customHeadersModal.controller";
export default /*@ngInject*/ function ($filter, $uibModal, helperService) {
    const vm = this;

    vm.$onInit = init;
    vm.$onChanges = saveForm;

    vm.connectionTypes = [];
    vm.openModal = openModal;
    vm.deleteCustomHeader = deleteCustomHeader;
    vm.updateRestKeys = updateRestKeys;

    const sqlKeys = ["CustomProduct_DatabaseName", "CustomProduct_sqlHostName", "CustomProduct_sqlPort", "CustomProduct_Password", "CustomProduct_User"],
        sftpKeys = ["CustomProduct_Server", "CustomProduct_Directory", "CustomProduct_sftpPassword", "CustomProduct_sftpUser"],
        oracleKeys = ["CustomProduct_orSqlHostName", "CustomProduct_orSqlPort", "CustomProduct_ServiceName", "CustomProduct_Schema", "CustomProduct_oraclePassword", "CustomProduct_oracleUser"],
        restBasicKeys = ["CustomProduct_REST_AuthType", "CustomProduct_REST_BaseApiUrl", "CustomProduct_REST_UserName", "CustomProduct_REST_Password"],
        restApiKeyKeys = ["CustomProduct_REST_AuthType", "CustomProduct_REST_BaseApiUrl", "CustomProduct_REST_ApiKey", "CustomProduct_REST_ApiKeyPrefix"],
        restClientCredentialKeys = ["CustomProduct_REST_AuthType", "CustomProduct_REST_BaseApiUrl", "CustomProduct_REST_ClientId", "CustomProduct_REST_ClientSecret", "CustomProduct_REST_TokenEndpoint", "CustomProduct_REST_AccessTokenPath", "CustomProduct_REST_AccessTokenPrefix"],
        restPrivateKeyJwtKeys = ["CustomProduct_REST_AuthType", "CustomProduct_REST_BaseApiUrl", "CustomProduct_REST_ClientId", "CustomProduct_REST_PrivateKey", "CustomProduct_REST_TokenEndpoint", "CustomProduct_REST_AccessTokenPath", "CustomProduct_REST_AccessTokenPrefix"],
        restSensitiveKeys = ["CustomProduct_REST_Password", "CustomProduct_REST_ClientSecret", "CustomProduct_REST_PrivateKey"];

    function init() {
        vm.product.updatePassword = false;
        vm.product.updateSftpPassword = false;
        vm.product.updateOraclePassword = false;
        if (vm.product.DataSource.Id === 6 && !vm.product.CustomProduct_REST_AuthType)
            vm.product.CustomProduct_REST_AuthType = { Id: 1, Type: 'Basic' };

        createCustomHeadersGrid();

        if (vm.product?.Type?.Type === 'AuditTrail' || vm.product.HasAuditTrailModule) {
            sqlKeys.push("currentProductConfig_Value");
        }
    }

    async function saveForm() {
        const product = vm.product;
        let keys = sqlKeys;

        if (vm.product.DataSource.Id === 2) {
            keys = sftpKeys;
        } else if (vm.product.DataSource.Id === 5) {
            keys = oracleKeys;
        } else if (vm.product.DataSource.Id === 6) {
            if (vm.product.CustomProduct_REST_AuthType?.Id === 1) {
                keys = restBasicKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 2) {
                keys = restApiKeyKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 3) {
                keys = restClientCredentialKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 4) {
                keys = restPrivateKeyJwtKeys;
            }

            if (vm.product.ConnectionExists) {
                keys = keys.filter(k => !restSensitiveKeys.includes(k));
            }
        }


        vm.saveStep(product, keys);
    }

    async function updateRestKeys() {
        const product = vm.product;
        let keys = sqlKeys;

        if (vm.product.DataSource.Id === 6) {
            if (vm.product.CustomProduct_REST_AuthType?.Id === 1) {
                keys = restBasicKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 2) {
                keys = restApiKeyKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 3) {
                keys = restClientCredentialKeys;
            } else if (vm.product.CustomProduct_REST_AuthType?.Id === 4) {
                keys = restPrivateKeyJwtKeys;
            }

            if (vm.product.ConnectionExists) {
                keys = keys.filter(k => !restSensitiveKeys.includes(k));
            }
        }

        vm.saveStep(product, keys);
    }

    function createCustomHeadersGrid() {
        let customHeadersGridColumns =
            [
                { field: "HeaderName", title: "Name"},
                { field: "HeaderValue", title: "Value"},
                { template: `<a ng-click="cpcsvm.deleteCustomHeader(dataItem)"><i class="glyphicon glyphicon-trash text-danger m-r-xs"></i>Delete</a>`, width: 70 }
            ];

        vm.customHeadersGridOptions = helperService.setNonPageableGridOptions(customHeadersGridColumns);
        vm.customHeadersGridOptions.selectable = false;
        vm.customHeadersGridOptions.noRecords = {
            template: "<div class='no-data-to-display-message'>No items to display</div>"
        };

        vm.customHeadersGridDataSource = new kendo.data.DataSource({
            transport: {
                read: async options => {
                    let response = [];
                    if (vm.product?.CustomProduct_REST_CustomHeaders) {
                        response = vm.product?.CustomProduct_REST_CustomHeaders;
                        response = $filter('orderBy')(response, 'HeaderName');
                    }
                    options.success(response);
                }
            }
        });
    }

    async function deleteCustomHeader(customHeader) {
        try {
            let dataSetHeaderIndex = vm.product.CustomProduct_REST_CustomHeaders.findIndex(headers => headers.Id === customHeader.Id);
            vm.product.CustomProduct_REST_CustomHeaders.splice(dataSetHeaderIndex, 1);
            vm.customHeadersGridDataSource.read();
        } catch {
            return;
        }

    }

    async function openModal() {
        let customHeaderModal = $uibModal.open({
            templateUrl: '/App/Components/maintainCustomHeaders/customHeadersModal/customHeadersModal.html',
            controller: customHeadersModalController,
            controllerAs: 'chmvm',
            backdrop: 'static',
            resolve: {
            }
        });

        try {
            let headerToCreate = await customHeaderModal.result;
            if (!vm.product.CustomProduct_REST_CustomHeaders) {
                vm.product.CustomProduct_REST_CustomHeaders = [];
            }
            vm.product.CustomProduct_REST_CustomHeaders.push(headerToCreate);
            vm.customHeadersGridDataSource.read();
        } catch {
            return;
        }
    }
}
     
